<div class="body">
  <div class="title text-center">
    <img class="images" src="assets/img/me_circle.png" alt="Me" style="width: 20rem; max-width: 90%;">
    <h2><b>Hello, My name is Mitch</b></h2>
  </div>
  <br/>
  <div class="main">
    <div class="container" id="intro">
      <p class="intro-text">
        I am a data scientist working in the pharmaceutical industry. I have extensive experience analyzing health insurance claims
        and building software. I hope to use my technical and analytical skills to contribute to public health research, especially in the study of autoimmune diseases.
      </p>
      <div class="interests-grid">
        <div class="interest-block">
          <h3>Academic Interests:</h3>
          <ul>
            <li>Storage and Application of Big Data</li>
            <li>Machine Learning and Predictive Analysis</li>
            <li>Cybersecurity and System Administration</li>
            <li>Relational and Non-relational Database Design</li>
            <li>Website and Web Application Development</li>
            <li>Linux and Open Source Software</li>
          </ul>
        </div>
        <div class="interest-block">
          <h3>Personal Interests:</h3>
          <ul>
            <li>Programming</li>
            <li>Video Games</li>
            <li>Going to Concerts</li>
            <li>Listening to Music</li>
            <li>Reading</li>
          </ul>
        </div>
      </div>
    </div>
    <br/>
      <h2>I am currently open to work offers</h2>
    <hr>
    <br/>
    <button id="btn" class="coolBeans" (click)="hideResume()">Show Resume</button>
    <br /><br />
    <div class="container" id="resume" style="display:none;">
      <div class="resume-title">Education</div>
      <div class="education">
        <p class="degree-title">Master of Science (August 2023)</p>
        <p class="school-title">Boston University School of Public Health, Boston</p>
        <div class="education-content">
          <p>Applied Biostatistics<br/>3.71 GPA</p>
        </div>
      </div>
      <div class="education">
        <p class="degree-title">Bachelor of Science (December 2019)</p>
        <p class="school-title">Eastern Michigan University, Ypsilanti</p>
        <div class="education-content">
          <p>Data Science and Analysis with Concentration on Theory<br/>
             3.72 GPA<br/>
             Magna Cum Laude<br/>
             Outstanding Senior Award for Excellence in Data Science</p>
        </div>
      </div>
      <div class="resume-title">Skills</div>
      <div class="skills-box">
        <div class="skills-content">
          <h4>Data Analysis</h4>
          <ul>
            <li>Data Mining</li>
            <li>Data Visualization with R</li>
            <li>Predictive Modeling</li>
            <li>Deep Learning with PyTorch</li>
            <li>Causal Directed Acyclic Graphs</li>
          </ul>
        </div>
        <div class="skills-content">
          <h4>Database Design</h4>
          <ul>
            <li>SQL & NoSQL</li>
            <li>ER & UML Diagrams</li>
            <li>Data Normalization</li>
            <li>Disaster Recovery</li>
            <li>Security & Performance</li>
          </ul>
        </div>
        <div class="skills-content">
          <h4>System Administration</h4>
          <ul>
            <li>Linux & Docker</li>
            <li>Web Server Hosting</li>
            <li>NetSuite & Salesforce</li>
            <li>Amazon AWS</li>
            <li>Red Hat JBoss EAP & IBM WebSphere</li>
          </ul>
        </div>
        <div class="skills-content">
          <h4>Languages & Frameworks</h4>
          <ul>
            <li>R</li>
            <li>Java / Kotlin</li>
            <li>Python</li>
            <li>Angular & TypeScript</li>
            <li>Shell Scripting</li>
          </ul>
        </div>
      </div>
      <div class="resume-title">Experience</div>
      <mat-tab-group>
        <mat-tab label="Pfizer - Global Medical Epidemiology">
          <div class="resume-header">Epidemiological Data Scientist</div>
          <div class="resume-subheader"><a href="https://www.pfizer.com/" target="_blank" rel="noopener noreferrer">Pfizer</a></div>
          <div class="resume-subheader">Oct 2023 - Present</div>
          <hr>
          <div class="resume-content">
            <ul>
                <li>Analyzed hundreds of millions of Medicare and Medicaid Claims to support real-world evidence generation</li>
                <li>Supported the deployment of SPOKE biomedical knowledge graph, integrating EHR data with curated scientific
                resources in Neo4j to uncover hidden relationships and accelerate hypothesis generation for clinical research</li>
                <li>Primary programmer in an observational study of cachexia in the US Medicare population, applying propensity scores
                and matching with regression modeling to assess treatment patterns, survival outcomes and patient characteristics</li>
                <li>Designed web apps for the rapid querying and analysis of longitudinal clinical datasets using R Shiny and D3.js</li>
                <li>Created tools to collect and aggregate information from public clinical trials databases (ClinicalTrials.gov, FDA)</li>
            </ul>
          </div>
        </mat-tab>
        <mat-tab label="Pfizer - Statistical Data Sciences and Analytics">
          <div class="resume-header">Intern</div>
          <div class="resume-subheader"><a href="https://www.pfizer.com/science/research-development/centers/ma_cambridge" target="_blank" rel="noopener noreferrer">Pfizer</a></div>
          <div class="resume-subheader">Jun 2023 - Aug 2023</div>
          <hr>
          <div class="resume-content">
            <ul>
              <li>Created CDISC compliant datasets and analysis reports with tables, listings, and figures using SAS</li>
              <li>Provided quality control for programmer deliverables for accuracy and consistency</li>
              <li>Contributed to a project-based effort to develop and implement an R Shiny app for interactive visualizations in clinical trial analysis</li>
            </ul>
          </div>
        </mat-tab>
        <mat-tab label="Boston University School of Public Health">
          <div class="resume-header">Research Assistant</div>
          <div class="resume-subheader"><a href="https://www.bu.edu/sph/profile/michael-lavalley/" target="_blank" rel="noopener noreferrer">Under the leadership of Dr. Mike LaValley</a></div>
          <div class="resume-subheader">Dec 2022 - May 2023</div>
          <hr>
          <div class="resume-content">
            <ul>
              <li>Identified clusters in a large dataset of patients who received knee replacements surgeries</li>
              <li>Performed survival analysis in R to develop a predictive model for if and when a knee replacement surgery is needed in patients with osteoarthritis based on their demographics and clinical characteristics</li>
              <li>Built and deployed an R Shiny application for interactive display of population distributions and summary tables</li>
            </ul>
          </div>
        </mat-tab>
        <mat-tab label="Blue Care Network of MI">
          <div class="resume-header">System Analyst</div>
          <div class="resume-subheader"><a href="https://www.bcbsm.com/" target="_blank" rel="noopener noreferrer">Blue Care Network of MI</a></div>
          <div class="resume-subheader">Mar 2020 - Jun 2022</div>
          <hr>
          <div class="resume-content">
            <ul>
              <li>Maintained and performed analysis on web applications and services supporting the largest health insurance network in the state</li>
              <li>Rotated 24/7 oncall support monitoring ongoing issues in critical backend systems for processing of insurance claims and enrollment</li>
              <li>Provided support across the company by writing and testing new features for a variety of systems across a large software portfolio</li>
              <li>Resolved issues in Spring Boot/Batch systems and JBoss EAP hosted apps after a database migration from Sybase to MS SQL Server</li>
              <li>Troubleshot user access issues with LDAP directory servers and Okta</li>
              <li>Automated the import of SSL certificates to keystore via bash scripts</li>
              <li>Created Maven archetypes using reactive Java libraries for asynchronous RDBMS usage with RESTful web services</li>
            </ul>
          </div>
        </mat-tab>
        <mat-tab label="National Food Group">
          <div class="resume-header">IT NetSuite Intern</div>
          <div class="resume-subheader"><a href="https://www.nationalfoodgroup.com/" target="_blank" rel="noopener noreferrer">National Food Group</a></div>
          <div class="resume-subheader">Oct 2019 - Feb 2020</div>
          <hr>
          <div class="resume-content">
            <ul>
              <li>Administered NetSuite user accounts and permissions</li>
              <li>Developed and tested workflows and JS scripts based on saved search conditions to handle automation of reporting</li>
              <li>Designed KPIs, reports, and portlets for employee dashboards</li>
              <li>Tracked inventory for specific items in different warehouses over time with interactive charts using D3.js and a Python data scraper</li>
              <li>Implemented new NetSuite features by communicating with other departments on their needs</li>
              <li>Performed data modeling for productivity improvement and marketing</li>
            </ul>
          </div>
        </mat-tab>
        <mat-tab label="Blue Cross Blue Shield of MI">
          <div class="resume-header">Operations Intern</div>
          <div class="resume-subheader"><a href="https://www.bcbsm.com/" target="_blank" rel="noopener noreferrer">Blue Cross Blue Shield of MI</a></div>
          <div class="resume-subheader">May 2019 - Aug 2019</div>
          <hr>
          <div class="resume-content">
            <ul>
              <li>Analyzed incoming applications with regular reports via MS Access</li>
              <li>Assigned system permissions to current and new employees</li>
              <li>Created and administered a SharePoint employee feedback page</li>
              <li>Organized reporting queries with an MS Access UI</li>
              <li>Automated mail categorization with Excel using VBA and VLOOKUP</li>
            </ul>
          </div>
        </mat-tab>
        <mat-tab label="Kaiser Optical">
          <div class="resume-header">Sales Intern</div>
          <div class="resume-subheader"><a href="https://kosi.com/" target="_blank" rel="noopener noreferrer">Kaiser Optical Systems, Inc.</a></div>
          <div class="resume-subheader">Jun 2016 - Sep 2016</div>
          <hr>
          <div class="resume-content">
            <ul>
              <li>Ran quantitative analyses and diagnosed problems on RAMAN spectrographs</li>
              <li>Updated online database of inventory using Salesforce, Agile, and FileMaker Pro</li>
              <li>Installed software and diagnosed issues with systems heading to demo</li>
            </ul>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
    <br/>
    <hr>
    <br/>
    <div id="faq" class="container">
        <div class="container-left">
            <mat-card class="basic-card">
                <mat-card-header>
                    <mat-card-title>What programming languages do I use?</mat-card-title>
                </mat-card-header>
                <mat-card-content>
                    <p>For data science I generally use R, but I'm equally familiar with many app building and machine learning techniques
                        in Python. I've also been trying out Kotlin in some of my notebooks.</p>
                    <p>I'm always learning new things in my free time. I'm experienced with many high and low level programming
                        languages so that at this point learning a new language is a matter of memorizing the syntax.</p>
                </mat-card-content>
            </mat-card>
        </div>
        <div class="container-right">
        <mat-card class="basic-card">
          <mat-card-header>
            <mat-card-title>What kind of coding do I do?</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <p>I'm familiar with full stack web application development, as well as data science and analysis.
              I've had a variety of jobs in the Tech Industry, which has given me experience in DevOps and frontend and backend development.
                I have the technical ability to develop and deploy web applications,
                and the analytical skills to generate reports and perform inference on datasets.</p>
            <p>My goal is to put my skills to use in the public health sector; possibly in research of rare and infectious disease
              or clinical trials of pharmaceuticals. This is why I earned my Master's degree in Biostatistics.</p>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="container-left">
        <mat-card class="basic-card">
          <mat-card-header>
            <mat-card-title>PC or Mac?</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <p>Neither. I've been running Linux on all of my personal computers since I was in middle school. In college I
              started making small changes to the kernel, and today I customize most everything on my OS to
              maximize my privacy and productivity. Gaming isn't an issue either, I was able to play Elden Ring on my Linux
              gaming PC straight out of the box with the same performance as Windows. As a developer I'm very particular
              about the tools I choose to use, and given the choice I will always take Free and Open Source Software.</p>
            <p>I use Arch btw</p>
          </mat-card-content>
        </mat-card>
      </div>
      <div class="container-right">
        <mat-card class="basic-card">
          <mat-card-header>
            <mat-card-title>What are some other facts about you?</mat-card-title>
          </mat-card-header>
          <mat-card-content>
            <ul class="faq-list">
              <li>Received the <a href="https://presidentialserviceawards.gov/" target="_blank" rel="noopener noreferrer">President's Volunteer Service Award</a> for volunteering at my library</li>
              <li>High school cross country mileage record for running 1,069 miles in 91 days</li>
              <li>Lead webmaster of my high school newspaper</li>
              <li>I've completed 2 full marathons and 14 half-marathons</li>
              <li>Previous treasurer and founding member of the Ping Pong Club &#64; EMU</li>
              <li>Implemented a music catalog application for a public radio station in colege</li>
              <li>I've seen the band Pigeons Playing Ping Pong live 13 times</li>
            </ul>
          </mat-card-content>
        </mat-card>
      </div>
    </div>
    <br/>
    <hr>
    <br/>
    <div class="container" id="connect">
      <mat-tab-group class="connect-tab-group">
        <mat-tab>
          <div class="resume-header text-center" style="padding-top: 15px; justify-content: center;">Connect with me</div>
          <hr>
          <div class="resume-content text-center" style="align-items: center;">
            <ul class="list-unstyled list-inline text-center" style="display: inline-flex; gap: 24px; align-items: center; justify-content: center; padding-top: 10px; padding-bottom: 20px; flex-wrap: wrap; margin-bottom: 0;">
              <li class="list-inline-item">
                <a href="https://www.linkedin.com/in/mitchell-henschel-2980a911b/" target="_blank" rel="noopener noreferrer" class="social-link">
                  <img src="assets/img/LI-Logo.png" alt="LinkedIn" style="max-height: 42px; width: auto;"/>
                </a>
              </li>
              <li class="list-inline-item">
                <a href="https://github.com/Elkip" target="_blank" rel="noopener noreferrer" class="social-link">
                  <img src="assets/img/Github.png" alt="GitHub" style="max-height: 42px; width: auto;"/>
                </a>
              </li>
              <li class="list-inline-item">
                <a href="https://codewars.com/users/Elkip" target="_blank" rel="noopener noreferrer" class="social-link">
                  <img src="assets/img/codewars.png" alt="CodeWars" class="img-responsive" style="max-height: 42px; width: auto;"/>
                </a>
              </li>
            </ul>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
    <br/>
    <div class="container footer-note">
      <p>Thanks for visiting my site.<br/>
        <small>Last updated 09/22/2026</small></p>
    </div>
    <br/><br/>
  </div>
</div>
